import React, { useRef, useState } from "react"
import PropTypes from "prop-types"

import ClearIcon from "./assets/clear.inline.svg"
import FindIcon from "./assets/find.inline.svg"
import styles from "./search.module.scss"

const debounceMs = 500

const Search = ({ className, onChange, placeholder }) => {
  const [value, setValue] = useState("")
  const debounceRef = useRef(0)

  const handleChange = e => {
    const search = e.target.value
    window.clearTimeout(debounceRef.current)
    setValue(search)

    debounceRef.current = window.setTimeout(() => {
      if (onChange) {
        onChange(search)
      }
    }, debounceMs)
  }

  const handleReset = () => {
    setValue("")

    if (onChange) {
      onChange("")
    }
  }

  return (
    <div className={`${styles.search} ${className || ""}`}>
      <input
        onChange={handleChange}
        value={value}
        type="text"
        placeholder={placeholder || "Найти"}
      />
      {!value && <FindIcon className={styles.findIcon} />}
      {Boolean(value) && (
        <button
          onClick={handleReset}
          className={styles.clearButton}
          type="button"
        >
          <ClearIcon />
        </button>
      )}
    </div>
  )
}

Search.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default Search
